<template>
  <div class="slider-home cat-carousel" >
    <div class="d-flex align-items-center justify-content-between w-100">
      <h2 class="float-left">Jaleko Recomenda</h2>
    </div>
    <carousel :dots="true" ref="carouselJalekoRecomenda">
      <carousel-item
        v-for="(recomenda, index) in jalekoRecomenda"
        :key="index"
        :titulo="recomenda.topicoNome"
        :imagem="obertUrlImagem(recomenda.urlImagemCapaCurso)"
        texto-url="Ver JalekoRecomenda"
        :url="`sala-de-aula/${recomenda.cursoReferencia}/${recomenda.moduloReferencia}/${recomenda.licaoReferencia}/${recomenda.topicoReferencia}`"
        :continuarAssistindo="true"
        :href="`sala-de-aula/${recomenda.cursoReferencia}/${recomenda.moduloReferencia}/${recomenda.licaoReferencia}/${recomenda.topicoReferencia}`"
      />
    </carousel>
  </div>
</template>

<script>
import CarouselItem from '@/core/components/CarouselItem'
import Carousel from '@/core/components/Carousel'
export default {
  name: 'JalekoRecomendaCarousel',
  components: { Carousel, CarouselItem },
  data () {
    return {
      jalekoRecomenda: [
        {
          cursoReferencia: 'histologia',
          moduloReferencia: 'introducao-e-metodos-de-analise-em-histologia',
          licaoReferencia: 'introducao-a-histologia',
          topicoReferencia: 'celulas',
          topicoNome: 'Células',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'histologia.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'emergencias-clinicas-anm',
          moduloReferencia: 'semana1',
          licaoReferencia: 'acidente-vascular-encefalico-anm',
          topicoReferencia: 'acidente-vascular-encefalico-com-dr-ricardo-novis',
          topicoNome: 'Acidente Vascular Encefálico com Dr. Ricardo Novis',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: '6038065c3f77f_capa-ec-anm.png',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'emergencias-clinicas-anm',
          moduloReferencia: 'semana1',
          licaoReferencia:
            'aspectos-psicossociais-atendimento-emergencia-brasil',
          topicoReferencia:
            'aspectos-psicossociais-do-atendimento-de-emergencia-no-brasil',
          topicoNome:
            'Aspectos Psicossociais do Atendimento de Emergência no Brasil',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: '6038065c3f77f_capa-ec-anm.png',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'cpb-microbio',
          moduloReferencia: 'introducao-a-microbiologia',
          licaoReferencia: 'Introducao-a-Microbiologia',
          topicoReferencia: 'introducao-43',
          topicoNome: 'Introdução à Microbiologia',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'microbiologia.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'emergencias-clinicas-anm',
          moduloReferencia: 'semana1',
          licaoReferencia: 'abertura-curso-anm',
          topicoReferencia:
            'live-de-abertura-do-curso-de-emergencias-clinicas-da-academia-nacional-de-medicina-2',
          topicoNome:
            'LIVE de abertura do curso de Emergências Clínicas da Academia Nacional de Medicina',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: '6038065c3f77f_capa-ec-anm.png',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'imunologia-basica',
          moduloReferencia: 'celulas-sanguineas',
          licaoReferencia: 'introducao-as-celulas-sanguineas',
          topicoReferencia: 'introducao-ao-sangue',
          topicoNome: 'Introdução às células sanguíneas',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'imunologia-basica.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'emergencias-clinicas-anm',
          moduloReferencia: 'apresentacao-do-curso',
          licaoReferencia: 'boas-vindas-anm',
          topicoReferencia:
            'introducao-ao-curso-emergencias-clinicas-da-academia-nacional-de-medicina',
          topicoNome:
            'Introdução ao Curso Emergências Clínicas da Academia Nacional de Medicina',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: '6038065c3f77f_capa-ec-anm.png',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'anatomia-cardiovascular',
          moduloReferencia: 'anatomia-cardiaca',
          licaoReferencia: 'mediastino',
          topicoReferencia: 'mediastino',
          topicoNome: 'Mediastino',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'anatomia-cardiovascular.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'mi-pediatria',
          moduloReferencia: 'pediatria-geral',
          licaoReferencia: 'anamnese-',
          topicoReferencia: 'anamnese-pediatrica-2',
          topicoNome: 'Anamnese pediátrica',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'pediatria.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'anamnese',
          moduloReferencia: 'colhendo-anamnese',
          licaoReferencia: 'historia-clinica',
          topicoReferencia: 'iniciando-sua-anamnese',
          topicoNome: 'Iniciando sua Anamnese',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'anamnese.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'anatomia-cardiovascular',
          moduloReferencia: 'anatomia-cardiaca',
          licaoReferencia: 'introducao-a-anatomia-cardiaca',
          topicoReferencia: 'sistema-cardiovascular-coracao',
          topicoNome: 'Sistema cardiovascular - Coração',
          tipoTopicoId: 1,
          tipoTopico: 'Modelos 3D',
          urlImagemCapaCurso: 'anatomia-cardiovascular.jpg',
          icone: 'mdi mdi-cube-scan'
        },
        {
          cursoReferencia: 'curso-de-neuroanatomia',
          moduloReferencia: 'organizacao-divisao-snc',
          licaoReferencia: 'origem-do-sist-nerv-sentral',
          topicoReferencia: 'organizacao-morfofuncional6435',
          topicoNome:
            'Organização morfofuncional do Sistema nervoso central (SNC)',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'neuroanatomia.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'anatomia-cardiovascular',
          moduloReferencia: 'anatomia-cardiaca',
          licaoReferencia: 'introducao-a-anatomia-cardiaca',
          topicoReferencia: 'introducao-a-anatomia-',
          topicoNome: 'Introdução a anatomia cardíaca',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'anatomia-cardiovascular.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'bioquimica',
          moduloReferencia: 'agua-e-suas-propriedades-1',
          licaoReferencia: 'propriedades-da-agua',
          topicoReferencia: 'propriedade-da-agua',
          topicoNome: 'Propriedade da água',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'bioquimica.jpg',
          icone: 'mdi mdi-video'
        },
        {
          cursoReferencia: 'farmacologia',
          moduloReferencia: 'farmacologia-geral',
          licaoReferencia: 'Conceitos-iniciais1092',
          topicoReferencia: 'conceitos-iniciais-da-farmacologia-parte-1-2',
          topicoNome: 'Conceitos iniciais da Farmacologia - Parte 1',
          tipoTopicoId: 1,
          tipoTopico: 'Vídeo',
          urlImagemCapaCurso: 'farmacologia.jpg',
          icone: 'mdi mdi-video'
        }
      ]
    }
  },
  methods: {
    applyOwlCarousel: function () {
      this.$refs.carouselJalekoRecomenda.applyOwlCarousel()
    },
    obertUrlImagem (urlImagem) {
      return `${process.env.VUE_APP_BASE_FILES_URL}cursos-plataforma/${urlImagem}`
    }
  }
}
</script>

<style scoped>
</style>
